import { NavLink, useLocation } from 'react-router-dom';
import {
  Home,
  Users,
  Calendar,
  FileText,
  Bell,
  Menu,
  FolderKanban,
  Inbox,
  Sparkles
} from '../../icons/wp-icons';
import { useNotifications } from '../../context/NotificationContext';
import { usePermissions, MODULES } from '../../context/PermissionContext';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { path: '/dashboard', icon: Home, label: 'Home', modul: MODULES.DASHBOARD },
  { path: '/ki-zentrale', icon: Sparkles, label: 'KI Zentrale', modul: MODULES.EINSTELLUNGEN },
  { path: '/kunden', icon: Users, label: 'Kunden', modul: MODULES.KUNDEN },
  { path: '/anfragen', icon: Inbox, label: 'Anfragen', modul: MODULES.ANFRAGEN },
  { path: '/kalender', icon: Calendar, label: 'Kalender', modul: MODULES.TERMINE },
  { path: '/benachrichtigungen', icon: Bell, label: 'Inbox', hasBadge: true },
  { path: '/menu', icon: Menu, label: 'Mehr' }
];

const HEYKIKI_ALLOWED_PATHS = ['/dashboard', '/anfragen', '/kunden', '/kalender', '/ki-zentrale', '/kostenvoranschlaege', '/rechnungen', '/einstellungen', '/katalog', '/projekte', '/mitarbeiter'];

export default function BottomNav() {
  const location = useLocation();
  const { unreadCount } = useNotifications();
  const { canView, loading } = usePermissions();
  const { user } = useAuth();

  const isHeykikiOrg = user?.organisation?.orgType === 'HEYKIKI';

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  // Filter items based on permissions
  // Wichtig: Während loading alle Items anzeigen, um Flackern zu vermeiden
  const filteredItems = navItems.filter(item => {
    if (isHeykikiOrg && !HEYKIKI_ALLOWED_PATHS.includes(item.path)) return false;
    if (!item.modul) return true; // Items ohne modul sind immer sichtbar
    if (loading) return true; // Während Berechtigungen laden, alle Items anzeigen
    return canView(item.modul);
  }).map(item => item.path === '/ki-zentrale' && isHeykikiOrg ? { ...item, label: 'KiKi Zentrale' } : item);

  return (
    <nav className="bottom-nav mobile-only">
      {filteredItems.map(({ path, icon: Icon, label, hasBadge }) => (
        <NavLink
          key={path}
          to={path}
          className={`bottom-nav-item ${isActive(path) ? 'active' : ''}`}
        >
          <div className="relative">
            <Icon />
            {hasBadge && unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full min-w-[16px] h-4 flex items-center justify-center px-1 font-medium">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </div>
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
